<template>
    <div class="age-modal" id="ageModal">
        <div class="age-modal-content text-light">
            <h2>🍷 {{ TR.age_modal_title }}</h2>
            <p>{{ TR.age_modal_content }}</p>
            <div class="age-buttons">
                <button class="age-btn yes" @click="confirmAge(true)">{{ TR.age_modal_yes }}</button>
                <button class="age-btn no" @click="confirmAge(false)">{{ TR.age_modal_no }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, watchEffect, ref } from 'vue';
import { useStore } from "@/store";

export default {
    name: 'AgeModalV',
    setup() {
        const store = useStore();
        const TR = ref();

        const confirmAge = (isAdult) => {
            if (isAdult) {
                document.getElementById('ageModal').style.display = 'none';
                document.getElementsByTagName('body')[0].style.overflow = 'auto';
                // initializeParticles();
            } else {
                alert(TR.value.age_modal_no_msg);
                window.location.href = 'https://www.google.com';
            }
        }

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        onMounted(() => {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        });

        return{
            TR,
            confirmAge,
        }
    },
}
</script>

<style lang="scss">
/* Age Verification Modal */
.age-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.age-modal-content {
    background: linear-gradient(135deg, #731818, #8b2635);
    padding: 3rem;
    border-radius: 20px;
    text-align: center;
    border: 1px solid rgba(255, 215, 0, 0.3);
    max-width: 500px;
}

.age-modal h2 {
    color: #ffd700;
    margin-bottom: 1rem;
}

.age-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 2rem;
}

.age-btn {
    padding: 1rem 2rem;
    border: none;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.age-btn.yes {
    background: linear-gradient(45deg, #ffd700, #4ecdc4);
    color: #000;
}

.age-btn.no {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.3);
}
</style>